import { css } from '@emotion/react'
import { DataPoint } from 'bold-ui/lib/components/Chart'
import moment, { Moment } from 'moment'
import { calculateAgeInWeeks } from 'util/date/calculateAge'

import { LinhaTooltipGrafico } from '../components/LinhaTooltipGrafico'

type TipoMedicaoLabel = 'Altura' | 'Comprimento' | 'Peso' | 'Perímetro cefálico'

type UnidadeDeMedida = 'cm' | 'kg'

interface TooltipGraficoAntropometriaProps {
  label: TipoMedicaoLabel
  unidadeDeMedida: UnidadeDeMedida
  points?: (DataPoint<Moment, number> & { seriesName: string })[]
  dataNascimento: Moment
  shouldRenderPreTermo: boolean
}

export const TooltipGraficoAntropometria = (props: Readonly<TooltipGraficoAntropometriaProps>) => {
  const { label, unidadeDeMedida, points, dataNascimento, shouldRenderPreTermo } = props

  if (!points || points.isEmpty()) return null

  const dataMedicao = moment(points[0].x)
  const idadeEmSemanas = calculateAgeInWeeks(dataNascimento.valueOf(), dataMedicao.valueOf())
  const dataFormatada = dataMedicao.format('DD/MM/YYYY')

  const styles = createStyles(shouldRenderPreTermo)

  return (
    <div css={styles.text}>
      {points.map((p) => (
        <LinhaTooltipGrafico key={p.y}>{`${label}: ${p.y} ${unidadeDeMedida}`}</LinhaTooltipGrafico>
      ))}

      {shouldRenderPreTermo && (
        <LinhaTooltipGrafico>
          {`Idade cronológica: ${'semana'.pluralizeAndConcatValue(idadeEmSemanas)}`}
        </LinhaTooltipGrafico>
      )}

      <LinhaTooltipGrafico>{`Data: ${dataFormatada}`}</LinhaTooltipGrafico>
    </div>
  )
}

const createStyles = (shouldRenderPreTermo: boolean) => ({
  text: css`
    text-align: ${shouldRenderPreTermo ? 'left' : 'inherit'};
  `,
})
